import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import * as dataSourceDimensions from "./dataSourceDimensions.actions";
import {DataSourceDimensionsState} from "./dataSourceDimensions";
import {DimensionComponentObject} from '../../classes/dimension-component-object';
import {TypedAction} from '@ngrx/store/src/models';
import {Serializers} from '../../interfaces/serializer';

import {DataSourceDimension} from '../../interfaces/dimensions';

const _reducer: ActionReducer<DataSourceDimensionsState> = createReducer(
  { serialized: [], componentObjects: [], loading: false, loaded: false },
  on(dataSourceDimensions.loadDataSourceDimensions, (state: DataSourceDimensionsState): DataSourceDimensionsState => {
    return {
      ...state,
      loading: true,
      loaded: false
    };
  }),
  on(dataSourceDimensions.loadDataSourceDimensionsSuccess, (state: DataSourceDimensionsState, action: TypedAction<string> & { dimensions: Serializers<DataSourceDimension> }): DataSourceDimensionsState => {
    return {
      serialized: action.dimensions,
      componentObjects: action.dimensions.map(dimension => new DimensionComponentObject(dimension)),
      loading: false,
      loaded: true
    };
  })
);

export const dataSourceDimensionsReducer: ActionReducer<DataSourceDimensionsState> = (state: DataSourceDimensionsState, action: Action) => {
  return _reducer(state, action);
};
